import {uuid} from './validate'
import {getCurrentCompanyUUID} from './company'

export const INVOICE_IMAGES_FOLDER = 'InvoiceImages';
export const COMPANY_LOGO_FOLDER = 'CompanyLogo';
export const EXPENSE_IMAGES_FOLDER = 'ExpenseImages';

function getLoginInformation() {
    return JSON.parse(localStorage.getItem('loginInformation')).objectData;
}

export function getFileUploadUrl(requestURL) {
    const baseUrl = requestURL.endsWith('/') ? requestURL : requestURL + '/';
    return new URL('file/upload', baseUrl).toString();
}

function getUploadCompanyUUID() {
    const companyUUID = getCurrentCompanyUUID();
    if (companyUUID == null || companyUUID === '') {
        throw new Error('companyUUID is required for file upload');
    }
    return companyUUID;
}

function getInnerUUID(file) {
    const innerUUID = file.innerUUID;
    if (innerUUID == null || innerUUID === '') {
        throw new Error('innerUUID is required for file upload');
    }
    return innerUUID;
}

export function getUploadRemoteKey(folderName, innerUUID) {
    return getUploadCompanyUUID() + "/" + folderName + "/" + innerUUID + ".jpg";
}

export function prepareFileUpload(uploadData, uploadFileMap, file, folderName) {
    const loginInformation = getLoginInformation();
    const innerUUID = uuid(null, 37);
    uploadData.email = loginInformation.email;
    uploadData.userUuid = loginInformation.userUuid;
    uploadData.companyUUID = getUploadCompanyUUID();
    uploadData.folderName = folderName;
    uploadData.innerUUID = innerUUID;
    uploadFileMap[file.uid] = {
        innerUUID: innerUUID
    };
}

export function takeUploadInnerUUID(uploadFileMap, file) {
    const uploadFile = uploadFileMap[file.uid];
    if (uploadFile == null) {
        throw new Error('upload file innerUUID is required');
    }
    const innerUUID = getInnerUUID(uploadFile);
    delete uploadFileMap[file.uid];
    return innerUUID;
}

export function discardPreparedFileUpload(uploadFileMap, file) {
    delete uploadFileMap[file.uid];
}

function appendDownloadCredentials(url) {
    const loginInformation = getLoginInformation();
    url.searchParams.set('email', loginInformation.email);
    if (loginInformation.userUuid != null && loginInformation.userUuid !== '') {
        url.searchParams.set('userUuid', loginInformation.userUuid);
    }
    return url.toString();
}

export function getDownloadV2Url(requestURL, remoteKey) {
    const baseUrl = requestURL.endsWith('/') ? requestURL : requestURL + '/';
    const url = new URL('file/downloadV2', baseUrl);
    url.searchParams.set('fileName', remoteKey);
    return appendDownloadCredentials(url);
}

export function getLegacyDownloadUrl(requestURL, fileName) {
    const baseUrl = requestURL.endsWith('/') ? requestURL : requestURL + '/';
    const url = new URL('file/download', baseUrl);
    url.searchParams.set('fileName', fileName);
    return appendDownloadCredentials(url);
}

export function getStoredImageDownloadUrl(requestURL, image) {
    if (image.imageSchemaVersion === 1) {
        return getDownloadV2Url(requestURL, image.remoteKey);
    }
    return getLegacyDownloadUrl(requestURL, image.imagePath);
}

export async function duplicateInvoiceImageFile(requestURL, invoiceImage) {
    const downloadResponse = await fetch(getStoredImageDownloadUrl(requestURL, invoiceImage), {
        method: 'GET',
        cache: 'force-cache'
    });
    if (!downloadResponse.ok) {
        throw new Error('invoice image download failed');
    }
    const imageBlob = await downloadResponse.blob();
    const loginInformation = getLoginInformation();
    const companyUUID = getUploadCompanyUUID();
    const innerUUID = uuid(null, 37);
    const remoteKey = companyUUID + "/" + INVOICE_IMAGES_FOLDER + "/" + innerUUID + ".jpg";
    const uploadData = new FormData();
    uploadData.append('file', imageBlob, innerUUID + '.jpg');
    uploadData.append('email', loginInformation.email);
    uploadData.append('userUuid', loginInformation.userUuid);
    uploadData.append('needUpdateCompanyLogo', '0');
    uploadData.append('companyUUID', companyUUID);
    uploadData.append('folderName', INVOICE_IMAGES_FOLDER);
    uploadData.append('innerUUID', innerUUID);

    const uploadResponse = await fetch(getFileUploadUrl(requestURL), {
        method: 'POST',
        body: uploadData
    });
    if (!uploadResponse.ok) {
        throw new Error('invoice image upload failed');
    }
    const responseData = await uploadResponse.json();
    if (responseData.errorCode !== 0) {
        throw new Error('invoice image upload response is invalid');
    }
    return {
        innerUUID: innerUUID,
        remoteKey: remoteKey,
        url: getDownloadV2Url(requestURL, remoteKey)
    };
}
